import { render } from "./addResource.vue?vue&type=template&id=359a4286&scoped=true&ts=true"
import script from "./addResource.vue?vue&type=script&lang=ts"
export * from "./addResource.vue?vue&type=script&lang=ts"

import "./addResource.vue?vue&type=style&index=0&id=359a4286&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/A-生产-h5-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-359a4286"]])

export default __exports__